export class ShouldNeverHappenError extends Error {
  constructor() {
    super("Something went wrong.");
    this.name = "ShouldNeverHappenError";
  }
}
